import React from 'react';
import {useTranslation} from 'react-i18next';
import EditorLayout from '../../../../components/Layouts/EditorLayout';
import {AdministratorGetSchema} from '../../../../api/DBSchema/Administrator';
import RowLayout from '../../../../components/Layouts/RowLayout';
import SMCLabel from '../../../../components/Simple/SMCLabel';
import {SMCCheckbox} from '../../../../components/Simple/SMCCheckbox';
import SMCButton from '../../../../components/Simple/SMCButton';
import {useBoolean} from '../../../../utils/hooks';
import ShowQRModal from '../../../PopupPages/ShowQRModal';
import {ObjectTypes} from '../../../../api/consts';

const pageSchema = AdministratorGetSchema.pages.twoStepAuth;
const pageId = pageSchema.pageId;

function AdministratorTwoStepAuth({
    origAdministratorObject,
    administratorObject
}) {
    const { t } = useTranslation();

    const pageData = administratorObject[pageId];
    const isTwoFactorAuth = pageData[pageSchema.isTwoFactorAuth];
    const twoFactorAuthQrUrl = pageData[pageSchema.twoFactorAuthQrUrl];

    // Take original admin email, and not the current
    const administratorEmail = origAdministratorObject[AdministratorGetSchema.pages.general.pageId]?.[AdministratorGetSchema.pages.general.email];
    const administratorId = administratorObject[AdministratorGetSchema.id];
    
    const [isQRCodeModalOpen, openQRCodeModal, closeQRCodeModal] = useBoolean(false);

    return (
        <EditorLayout>
            <RowLayout spacing="6px">
                <SMCLabel inline>{t('SMP.PAGE.2FA_ENABLE')}</SMCLabel>
                {/* isTwoFactorAuth - readonly */}
                <SMCCheckbox checked={isTwoFactorAuth} disabled /> 
                <SMCButton disabled={!isTwoFactorAuth} onClick={openQRCodeModal} ignoreDisabledContext>{t('SMP.USERS.TABLE.PAGES.2FA.SHOW_QR')}</SMCButton>
            </RowLayout>
            {/* Popup windows */}
            <ShowQRModal
                isOpen={isQRCodeModalOpen}
                onRequestClose={closeQRCodeModal}
                qrLink={twoFactorAuthQrUrl}
                userEmail={administratorEmail}
                objectType={ObjectTypes.ADMINISTRATOR}
                userId={administratorId}
            />
        </EditorLayout>
    )
}

export default AdministratorTwoStepAuth;